import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
export const claimGroupMenuItemsCreator = _ref => {
  let {
    company,
    allClaimGroups
  } = _ref;
  if (!(company !== null && company !== void 0 && company.id)) return [];
  const menuItems = [];
  let bsfzSubMenuItems = allClaimGroups.map(claimGroup => {
    // claimGroup.name to replaced to get the year values only
    return {
      element_id: claimGroup.id,
      text: 'project_overview',
      link: "claim_groups/".concat(claimGroup.id, "/project_overview"),
      hasLinkReady: true
    };
  });
  const createElsterObject = elster => {
    const dateFormated = dateToFormat => createTimezonedDate(dateToFormat, true).toCustomLocaleDateString();
    return {
      element_id: elster.id,
      text: "".concat(dateFormated(elster.start_date), " - ").concat(dateFormated(elster.end_date)),
      link: "companies/".concat(company.id, "/").concat(elster.id, "/elsters"),
      hasLinkReady: true
    };
  };
  const elsters = [];
  const hiddenElsters = [];
  company.elsters_dates_asc.forEach(elster => {
    if (elster.hidden) {
      hiddenElsters.push(createElsterObject(elster));
    } else {
      elsters.push(createElsterObject(elster));
    }
  });
  menuItems.push({
    text: 'bfsz',
    isOpen: true,
    subMenu: bsfzSubMenuItems
  });
  menuItems.push({
    text: 'elster',
    isOpen: true,
    subMenu: elsters
  });
  if (hiddenElsters.length > 0) {
    menuItems.push({
      text: 'hidden_elsters',
      isOpen: false,
      subMenu: hiddenElsters
    });
  }
  return menuItems;
};